import {AbstractControlValueAccessor} from "../abstract-control-value-accessor";
import {EditableTextValue} from "@portal-workspace/grow-shared-library";
import {Component, forwardRef, inject, OnInit} from "@angular/core";
import {MARK, Mark} from "@portal-workspace/grow-ui-library/mark";
import { AsyncPipe, CommonModule, JsonPipe } from "@angular/common";
import {FlexModule} from "@angular/flex-layout/flex";
import {MatTooltipModule} from "@angular/material/tooltip";
import {FormBuilder, FormControl, NG_VALUE_ACCESSOR, ReactiveFormsModule, Validators} from "@angular/forms";
import {MatButtonModule} from "@angular/material/button";
import {formControlErrorKeys, formControlErrorMessage} from "../component-utils";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";
import {Mode} from "@ngneat/edit-in-place/lib/mode";
import {EditableComponent, EditableSaveDirective, EditModeDirective, ViewModeDirective} from "@ngneat/edit-in-place";


@Component({
  selector: 'editable-text',
  templateUrl: './editable-text.component.html',
  styleUrls: ['./editable-text.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FlexModule,
    JsonPipe,
    AsyncPipe,
    MatTooltipModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    EditableComponent,
    EditableSaveDirective,
    EditModeDirective,
    ViewModeDirective,
  ],
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(()=>EditableTextComponent), multi: true},
    { provide: MARK, useExisting: forwardRef(() => EditableTextComponent), multi: true},
  ]
})
export class EditableTextComponent extends AbstractControlValueAccessor<EditableTextValue> implements OnInit, Mark {

  mode: Mode = 'view';

  readValue: EditableTextValue = null;
  formControl!: FormControl<EditableTextValue>;

  formBuilder = inject(FormBuilder);

  errorKeys = formControlErrorKeys;
  errorMessage = formControlErrorMessage;

  constructor() {
    super();
    this.formControl = this.formBuilder.control(null, [Validators.required]);
  }


  mark(): void {
    this.formControl.markAllAsTouched();
  }

  ngOnInit(): void {
  }

  doWriteValue(v?: EditableTextValue | undefined): void | EditableTextValue {
    if (v != null || v != undefined) {
      this.readValue = v;
      this.formControl.setValue(v);
    } else {
      this.readValue = null;
      this.formControl.setValue(null);
    }
  }


  onSave() {
    if (this.formControl.valid) {
      this.readValue = this.formControl.value;
      this.propagateChange(this.readValue);
    } else {
      this.propagateChange(null);
    }
  }

  modeChange($event: Mode) {
    this.mode = $event;
  }
}
